









import {defineComponent, ref, watch} from "@vue/composition-api"
import DataGrid from "@/components/DataGrid.vue"
import WidgetFrame from "@/components/WidgetFrame.vue"

export default defineComponent({
  props: {
    config: Object,
    dataFetcher: Function,
    fields: Array,
    titleCallback: Function,
  },
  components: {
    WidgetFrame, DataGrid,
  },
  setup(props) {
    const title = ref("")
    let refresh = ref(0)
    watch(() => props.config, async (config) => {
      if (config) {
        refresh.value++
        title.value = props.titleCallback && props.titleCallback(config)
      }
    }, {deep: true})
    return {refresh, title}
  },
})
